import { init } from "../init-streaming";
import { JiraSoftwarePage } from "../pages/software/jira/anchors/jira-software-page";
init(JiraSoftwarePage);
